import { Reducer } from 'redux';

export default function createReducer<State>(
  initialState: State,
  handlers: { [key: string]: Reducer<State> }
): Reducer<State> {
  return function reducer(state = initialState, action) {
    if (handlers && handlers[action.type]) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

export const setStatusForKey = (state, { type, payload }) =>
  Object.assign({}, state, { [payload.id]: type });

export function mergeById(state, action) {
  const { payload } = action;
  const old = state[payload.id] || {};
  return {
    ...state,
    [payload.id]: { ...old, ...payload }
  };
}

type StatusMap = { [key: number]: string };

export function createCollectionStatusReducer(...statues) {
  return createReducer<StatusMap>(
    {},
    statues.reduce((handlers, status) => {
      handlers[status] = setStatusForKey;
      return handlers;
    }, {})
  );
}

type Collection<T> = { [key: number]: T };

export function createCollectionReducer<Type>(...statues) {
  return createReducer<Collection<Type>>(
    {},
    statues.reduce((handlers, status) => {
      handlers[status] = mergeById;
      return handlers;
    }, {})
  );
}
